/*
 * Awhi — shared subtle-motion system (GSAP + ScrollTrigger).
 *
 * One init for the whole site so every section animates on the same
 * easing and register. Data-attribute driven — no per-section JS:
 *
 *   data-awhi-reveal            fade + short rise as it enters view
 *   data-awhi-reveal-stagger    same, but staggers its direct children
 *   data-awhi-parallax="-40"    drift N px against scroll (depth layers)
 *
 * Register is deliberately calm: ~0.7s, ease-out, small distances, no
 * bounce. prefers-reduced-motion OR no-GSAP => everything is shown at
 * its final state and nothing animates. Home-only load (theme.liquid).
 */
(function () {
  'use strict';

  if (window.AwhiMotionBound) return;
  window.AwhiMotionBound = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gsap = window.gsap;
  var hasGsap = !!(gsap && gsap.registerPlugin && window.ScrollTrigger);

  /* Fallback: reveal targets carry an initial hidden state via CSS
     (.awhi-anim). If we're not animating, strip it so content shows. */
  function showAll() {
    var hidden = document.querySelectorAll('.awhi-anim');
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].classList.remove('awhi-anim');
    }
  }

  if (reduce || !hasGsap) {
    showAll();
    return;
  }

  gsap.registerPlugin(window.ScrollTrigger);

  function init() {
    try {
      build();
    } catch (err) {
      /* Any failure must not leave content stuck hidden. */
      showAll();
    }
  }

  function build() {
    /* Reveals — fade + rise. Stagger variant animates children. */
    var reveals = document.querySelectorAll('[data-awhi-reveal], [data-awhi-reveal-stagger]');
    reveals.forEach(function (el) {
      var isStagger = el.hasAttribute('data-awhi-reveal-stagger');
      var targets = isStagger ? el.children : el;

      gsap.set(targets, { autoAlpha: 0, y: 26 });
      el.classList.remove('awhi-anim');

      gsap.to(targets, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        ease: 'power2.out',
        stagger: isStagger ? 0.06 : 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 82%',
          once: true
        }
      });
    });

    /* Parallax — element drifts against scroll while its section is in
       view. Amount (px) from the attribute; negative = moves up. */
    var layers = document.querySelectorAll('[data-awhi-parallax]');
    layers.forEach(function (el) {
      var amount = parseFloat(el.getAttribute('data-awhi-parallax')) || 0;
      if (!amount) return;
      el.classList.remove('awhi-anim');
      gsap.to(el, {
        y: amount,
        ease: 'none',
        scrollTrigger: {
          trigger: el.closest('[data-awhi-parallax-scope]') || el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.6
        }
      });
    });

    /* Fonts settle late — recalc trigger positions once they land. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        window.ScrollTrigger.refresh();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
